import React, { useEffect } from 'react';
import { Col, Container, Row } from 'shards-react';
import PageTitle from '../components/common/PageTitle';
import Notification from '../components/common/Notification';
import SelectCondition from '../components/manage-condition/SelectCondition';
import ChangeViewMode from '../components/manage-condition/ChangeViewMode';
import SwitchConditionType from '../components/manage-condition/SwitchConditionType';
import ConditionStatusActions from '../components/manage-condition/ConditionStatusActions';
import EditConditionDetail from '../components/manage-condition/EditConditionDetail';
import ModalEditConditionOrdinary from '../components/manage-condition/ModalEditConditionOrdinary';
import ModalRequestApproval from '../components/manage-condition/ModalRequestApproval';
import ConditionOrdinary from '../components/manage-condition/ConditionOrdinary';
import ConditionCustomize from '../components/manage-condition/ConditionCustomize';
import { useTranslation } from 'react-i18next';
import { RootState, useDispatch, useSelector } from '../redux/store';
import { resetMessage, setSelectedViewMode, resetCondition } from '../redux/slices/condition';
import { getOrganizations } from '../redux/slices/organization';
import { getBusinessTypeOptions, getOrganizationBaseOptions, getSteelCategoryOptions, getSteelMakerOptions, getTradingCompanyOptions } from '../redux/slices/options';
import { getAdminPowerUsers } from '../redux/slices/user';
import { CONDITION_VIEW_MODES } from '../constants';

const ManageCondition = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { hasError, serverMessage } = useSelector((state: RootState) => state.condition);

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // /**
  //  * 初期表示は承認済みビュー・通常可視制御にする。
  //  * ページで使用するデータを取得する
  //  */
  useEffect(() => {
    dispatch(setSelectedViewMode(CONDITION_VIEW_MODES.APPROVED));
    dispatch(getAdminPowerUsers());
    dispatch(getOrganizations());
    dispatch(getOrganizationBaseOptions());
    dispatch(getBusinessTypeOptions());
    dispatch(getSteelCategoryOptions());
    dispatch(getSteelMakerOptions());
    dispatch(getTradingCompanyOptions());
    return () => {
      dispatch(resetCondition());
    };
  }, []);

  // EVENT HANDLER
  // ================================================================================

  /**
   * メッセージを消す
   */
  const dismiss = (): void => {
    dispatch(resetMessage());
  };

  // VIEW
  // ================================================================================

  return (
    <Container fluid className="main-content-container px-4">
      <Row id="pageTitle" noGutters className="page-header py-4">
        <PageTitle sm="4" title={t('condition.control')} subtitle="Visible Control" className="text-sm-left" />
        <Col sm="4" className="col d-flex align-items-center">
          <ChangeViewMode />
        </Col>
      </Row>

      <Notification theme={hasError ? 'danger' : 'success'} isOpen={serverMessage !== undefined && serverMessage.length > 0} message={serverMessage} dismissCallback={dismiss} />

      <Row className="mb-4">
        <Col sm="12" md="6" className="mb-sm-4 mb-md-0">
          <SelectCondition />
        </Col>
        <Col sm="12" md="6" className="d-inline-flex flex-row-reverse align-items-center justify-content-start">
          <ConditionStatusActions />
        </Col>
      </Row>

      <SwitchConditionType />
      <EditConditionDetail />

      <ConditionOrdinary />
      <ConditionCustomize />

      <ModalEditConditionOrdinary />
      <ModalRequestApproval />
    </Container>
  );
};

export default ManageCondition;
